export default {
  routerList: [
    {
      path: '/homePageApp',
      component: () => import('@/views/indexApp/home/homePage.vue'),
      name: '主页（手机端）',
      children: []
    },
  ]
}
